<template>
  <stu-main @back="goBack">
    <template slot="nav">
      <div class="teaDetailNav">
        <p>线上继续教育</p>
      </div>
    </template>
    <template slot="main">
      <div class="teaDetailMain">
        <yioks-loading v-show="loading"></yioks-loading>
        <vue-scroll :ops="ops" ref="vs">
          <div class="mainBody" v-if="!loading">
            <!-- 等级继续教育学时汇总 -->
            <template
              v-if="coachHistoryInfo.coachUser.continueCumulativeHoursCount"
            >
              <div class="title">
                <v-icon
                  class="logo"
                  name="regular/file-alt"
                  scale="1.8"
                ></v-icon>
                <p>等级继续教育学时汇总</p>
              </div>
              <div class="lincense_info_wrap">
                <div class="licenseInfo rankInfo">
                  <el-row class="score-row">
                    <el-col :span="7" class="score-col">
                      <p>
                        等级：{{
                        coachHistoryInfo.coachUser.coachRankType | level
                        }}
                      </p>
                    </el-col>
                    <el-col :span="9" class="score-col">
                      <p>
                        已获得学时：{{
                        coachHistoryInfo.coachUser
                        .continueCumulativeHoursCount || "--"
                        }}
                        &nbsp;&nbsp;&nbsp;未完成学时：{{coachHistoryInfo.coachUser.coachRankType | coachHoursALL(coachHistoryInfo.coachUser.continueCumulativeHoursCount) }}
                      </p>
                    </el-col>
                    <el-col :span="8" class="score-col">
                      <p>
                        学时有效期至：{{
                        coachHistoryInfo.coachUser.continueCreateDate
                        | continueEndDate
                        }}
                      </p>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </template>
            <div class="title">
              <v-icon class="logo" name="regular/file-alt" scale="1.8"></v-icon>
              <p>线上继续教育</p>
            </div>
            <template v-if="showList">
              <div class="scrollArea">
                <div class="tbodyWrap">
                  <div class="tbody">
                    <div class="tr" v-for="(item, index) in list" :key="index">
                      <div class="td detail">
                        <p class="title" style="padding: 0">
                          {{ item.name }}
                        </p>
                        <div class="blockWrap">
                          <div class="left">
                            <div class="wrap">
                              <div class="imgWrap">
                                <img
                                  :src="
                                    !item.moment_picture
                                      ? classSrc
                                      : item.moment_picture
                                  "
                                  @error="imgListErr(index)"
                                  alt
                                />
                                <yioks-status :status="item.status" :type="`education`"></yioks-status>
                              </div>
                              <div class="infoWrap">
                                <p>
                                  学习日期：{{
                                  item.start_date | time(false)
                                  }}
                                  至 {{ item.end_date | time(false) }}
                                </p>
                                <p v-if="item.level === 'E'">级别：D级助理 <span style="font-size: 14px">（{{item.education_type | classTypeFilter(isFive)}}）</span></p>
                                <p v-else-if="['GC', 'GB', 'GA','F1','F2','PRO' ].includes( item.level)">级别：{{item.level | classInfoBoxLevelFilter(isFive)}} （{{item.education_type | classTypeFilter(isFive)}}）</p>
                                <p v-else>级别：{{item.level | classInfoBoxLevelFilter(isFive)}}级（{{item.education_type | classTypeFilter(isFive)}}）</p>
                                
                                <p >
                                  学时：{{ item.hours || '--' }}
                                </p>
                                <p>
                                  学习状态：{{item.study_status | educationLearnStatusFilter}}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="right" v-if="item.status === 'Initiated'">
                            <div class="btn" style="background-color:#b2b2b2;cursor: no-drop;width: 145px">
                              <p>继续教育未开始</p>
                            </div>
                          </div>
                          <div class="right" v-else>
                            <div class="btn"  @click="lookDetail(item.edu_id)" v-if="['Initiated','Incomplete'].includes(item.study_status)">
                              <p>进入学习</p>
                            </div>
                            <div class="btn"  @click="lookDetail(item.edu_id)" v-else>
                              <p>查看详情</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--<div id="paging">
                              <yioks-paging :paging="paging" @goto-page="gotoPage($event)"></yioks-paging>
                            </div>-->
            </template>
            <template v-else>
              <yioks-empty
                :h="'60%'"
                tips="暂时没有线上继续教育信息"
                style="margin-top: 180px"
                :class="{ certificate_empty: showEmpty }"
              ></yioks-empty>
            </template>
          </div>
        </vue-scroll>
        
      </div>
    </template>
  </stu-main>
</template>
<script>
  import ops from "@/assets/js/vuescrollOption";
  import "vue-awesome/icons/regular/file-alt";
  import classSrc from "@/assets/images/class_logo.png";
  import { getStuHistoryTrian } from "@/api/system_manager/api";
  import { userStatus, LevelFilters, typeFilters } from "@/assets/js/status";
  import { info_view, } from "@/api/ab_signup/api";
  import { isEvaluated, completeExpirence } from "@/api/training_student/api";
  import { requiredItem } from "@/assets/js/formRules";
  import fiveMixins from "@/minix/fiveMixins";
  import { educationLearnStatusFilter,coachHoursALL } from '@/assets/js/yioksFilters';
  import { getEducationListToStu } from "@/api/education/education";
  
  const HOSTURL = process.env.VUE_APP_URL;
  
  export default {
    name: "educationList",
    mixins: [fiveMixins],
    data() {
      return {
        user_id: this.$route.query.u_id,
        ops: ops(),
        allDisabled: false,
        disScrollOpt: ops(true),
        showList: false,
        showEmpty: false,
        classSrc: classSrc,
        info: {},
        list: [],
        loading: true,
        tips: {
          title: "",
          button_text: "",
          show_type: "",
        },
        url: "",
        license: {},
        coachHistoryInfo: {
          coachUser: {},
        },
      };
    },
    components: {
      "stu-main": () => import("@/components/LayOut/Common/up-down"),
      "stu-edit": () => import("@/views/system_manager/student/stu-edit"),
      "stu-detail-info": () => import("@/components/StuDeatilInfo/StuDeatilInfo"),
      // "yioks-paging": () => import("@/components/Pagination/Page"),
      "yioks-status": () => import("@/components/Tips/Status"),
      "v-icon": () => import("vue-awesome/components/Icon"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
      "yioks-loading": () => import("@/components/Loading/Loading"),
      "select-organ": () => import("@/components/Tips/select-organ"),
    },
    filters: {
      educationLearnStatusFilter,
      coachHoursALL,
      userText(status) {
        return userStatus(status);
      },
      level(level) {
        if (!level) {
          return "--";
        }
        return LevelFilters(level);
      },
      continueEndDate(dateText) {
        // 2022.08.19修改 学时有效期改为当年有效
        let date = new Date();
        return date.getFullYear() + "-12-31";
      },
      classType(level) {
        return typeFilters(level);
      },
    },
    created() {
      // this.setData();
      this.getStuEducation();
      this.getStuList();
      
    },
    methods: {
      
      goBack() {
        this.$router.go(-1);
      },
      
      getStuEducation(){
        this.showList = false;
        getEducationListToStu({})
        .then((res) => {
          this.loading = false;
          const { result } = res.data;
          this.list = result.list;
          if (this.list.length > 0) {
            this.showList = true;
            this.showEmpty = false;
          } else {
            this.showList = false;
            this.showEmpty = true;
          }
        })
        .catch((err) => {
          console.error(err);
        });
      },
      getStuList() {
        this.showList = false;
        getStuHistoryTrian({
          uid: this.user_id,
        })
        .then((res) => {
          this.loading = false;
          const { result } = res.data;
          if (result.coachHistoryInfo) {
            const { coachUser} = result.coachHistoryInfo;
            if (coachUser) this.coachHistoryInfo.coachUser = coachUser; // 获取用户信息
          }
        })
        .catch((err) => {
          console.error(err);
        });
      },
      
      imgListErr(idx) {
        this.$set(this.list[idx], "moment_picture", this.imgSrc);
      },
  
      lookDetail(edu_id) {
        this.$router.push({
          path: "education_info_to_stu",
          query: {
            edu_id
          },
        });
      },
      
    },
  };
</script>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  @import '~@/assets/css/mixin'
  .teaDetailNav, .teaDetailMain
    flex 1 1 auto
    height 100%
  .to-eval
    font-size 16px
    text-align center
    img
      width 100px
    .tips
      margin-bottom 15px
  .teaDetailNav
    padding-right 15px
    display flex
    align-items center
    justify-content space-between
    position relative
    font-size $font_size_big
    .question
      margin-left 200px
      cursor pointer
    .ab_enter
      /* position absolute */
      /* right 15px */
      /* top 5px */
      /* transform translateY(50%) */
      border-radius 5px 5px 5px 5px
      padding 5px 10px
      line-height 1.2
      font-size $font_size_base
      color $color_white
      background-color $color_suc
      cursor pointer
    .abc_enter
      /* position absolute */
      /* right 15px */
      /* top 5px */
      /* transform translateY(50%) */
      border-radius 5px 5px 5px 5px
      padding 5px 10px
      line-height 1.2
      font-size $font_size_base
      color $color_white
      background-color $color_primary
      cursor pointer
  .teaDetailMain
    width 100%
    padding-top 10px
    padding-bottom 10px
    background-color $block_bg_color_base
    .mainBody
      display block
      height 100%
      .title
        padding 20px 20px 0 20px
        display flex
        p
          font-size 16px
          align-self flex-end
          margin-left 5px
        .upload_enter
          /* transform translateY(50%) */
          color $color_suc
          cursor pointer
          font-size 15px
      .lincense_info_wrap
        padding 0 20px
        margin-top 15px
      .lincense_info_empty
        padding 0 20px
      .licenseInfo
        width 100%
        position relative
        border 1px solid $color_white
        .score-row
          border-bottom 1px solid $color_white
          &:last-child
            border-bottom none
          .score-col
            text-align center
            border-left 1px solid $color_white
            &:first-child
              border-left none
            p
              margin 10px
              font-size $font_size_medium
              word-break break-all
              &.score-note
                text-align left
      .scrollArea
        width 100%
        height 100%
        padding 15px 0 15px
        .enter_question
          padding 15px 20px 0 20px
          span
            color $color_white
          .enter_question_span
            text-align right
            margin-top 10px
        /* cursor pointer; */
        .tbodyWrap
          padding 0 20px
          .tbody
            .rankInfo
              width 100%
              margin-bottom 30px
              position relative
              border 1px solid $color_white
              .score-row
                border-bottom 1px solid $color_white
                &:last-child
                  border-bottom none
                .score-col
                  text-align center
                  border-left 1px solid $color_white
                  &:first-child
                    border-left none
                  p
                    margin 10px
                    font-size $font_size_medium
                    word-break break-all
                    &.score-note
                      text-align left
              .bz
                .score-col
                  text-align left
              .dashed-line
                width 100%
                position absolute
                bottom -32px
                left 0
                border 1px dashed $color_white
            .tr
              display flex
              margin 0 0 30px
              .detail
                flex 1 1 auto
                padding 10px
                border 1px solid $color_white
                .title
                  font-size 20px
                .blockWrap
                  display flex
                  justify-content space-between
                  .left
                    flex 1 1 auto
                    .wrap
                      margin 5px 0 0
                      display flex
                      .imgWrap
                        flex 0 0 auto
                        width 135px
                        height 100px
                        position relative
                        img
                          width 100%
                          height 100%
                      .infoWrap
                        padding 0 0 0 20px
                        flex 1 1 auto
                        display flex
                        flex-direction column
                        justify-content space-around
                        font-size $font_size_medium
                        p
                          max-width 445px
                          white-space nowrap
                          overflow hidden
                          text-overflow ellipsis
                  .right
                    padding 20px 0 0
                    display flex
                    justify-content center
                    .btn
                      width 100px
                      height 40px
                      display flex
                      justify-content center
                      align-items center
                      font-size $font_size_big
                      line-height $font_size_big
                      background-color $color_suc
                      cursor pointer
                      user-select none
          .licenseInfo
            width 100%
            margin-bottom 30px
            position relative
            border 1px solid $color_white
            .score-row
              border-bottom 1px solid $color_white
              &:last-child
                border-bottom none
              .score-col
                text-align center
                border-left 1px solid $color_white
                &:first-child
                  border-left none
                p
                  margin 10px
                  font-size $font_size_medium
                  word-break break-all
                  &.score-note
                    text-align left
        .notice
          padding 20px
          .title
            color $color_err
            margin-bottom 10px
          /* font-size 18px */
          .info
            margin-top 10px
      .certificate_empty
        height 50%
      .license_empty
        height 50%
        .wrap
          img
            width 150px
      .notice
        padding 20px
        .title
          color $color_err
          margin-bottom 10px
        /* font-size 18px */
        .info
          margin-top 10px
  /* #paging
  width 100%
  height 77px */
  .empty-input
    width 100%
    height 42px
    box-sizing border-box
    display flex
    align-items center
    justify-content center
    font-size 16px
    .label-name
      min-width 80px
  .suc
    color #4cd964
  .err
    color $color_danger
  .btn
    cursor pointer
    user-select none
  .empty-data-footer
    width 45%
    margin 0 auto
    display flex
    justify-content space-around
  .complete-tips
    display flex
    margin-left 40px
  .tips-input
    width 380px
  .red-text
    color $color_both_err
</style>

<style lang="stylus">
  .license_empty, .certificate_empty
    img
      width 150px
    p
      font-size 16px !important
</style>


